<template>
  <div class="ob-page">
    <div class="page-content">
      <div class="img-view">
        <div class="img-text">
          <p>
            The main organs of the World Federation are:
            <ul>
              <li>The World Congress, which is the supreme authority of the World Federation;</li>
              <li>The Executive Board, which is the governing body of the World Federation while the
                World Congress is not in session;
              </li>
              <li>The Secretariat, which is the permanent office of the World Federation.
              </li>
            </ul>
          </p>

          <p>
            In addition, regional federations are created as branches of the World Federation, to
            foster and coordinate the development of the UNESCO Clubs Movement and implement its
            programs on a regional basis.
          </p>
        </div>
        <img src="@/assets/images/about/about-img-ob.jpg"/>
      </div>
      <div class="page-title" id="bar11">World Congress</div>
      <div class="text">
        <p>
          The World Congress, the supreme authority of the World Federation, convenes in ordinary
          session every four years. It is composed of delegates nominated by full members. Each full
          member is entitled to one voting delegate, provided all membership dues are current.
          Associate members and alternate delegates may participate as observers without voting
          rights.
        </p>
        <p>
          The World Congress addresses issues and coordinates and integrates the Federation's
          programs. Its main functions include:
          <ul>
            <li>to adopt the General Rules;</li>
            <li>to lay down guidelines for the proper functioning of the World Federation;</li>
            <li> to approve the activity and financial reports for the period since the previous
              World
              Congress;
            </li>
            <li>to adopt the programme and budgetary guidelines proposed by the Executive Board for
              the period up to the following World Congress;
            </li>
            <li>to elect the Executive Board of the World Federation.</li>
          </ul>
        </p>
      </div>

      <div class="list-item" @click="goAboutList('/aboutWorld')">List of previous World Congresses
        of WFUCA
      </div>

      <div class="page-title" id="bar22">Executive Board</div>
      <div class="text">
        The Executive Board is accountable to the World Congress for carrying out the World
        Federation's duties, which consists of the members elected by the World Congress (including:
        a
        President, five Vice-Presidents, five Executive Committee members and a Treasurer), and
        ex-officio members, who are representatives of National Federations that meet the criteria
        of
        length of service and contribution as defined in the Rules of Procedure.
      </div>
      <div class="list-item" @click="goAboutList('/AboutSession')">List of previous sessions of
        Executive Board of WFUCA
      </div>

      <div class="sub-title">The Current Executive Board includes:</div>
      <div class="people-view">
        <el-row :gutter="20" class="people-row">
          <el-col :span="8">
            <div class="title">President</div>
            <!-- <img src="@/assets/images/gov/people01.png"/> -->
            <img style="width: 100%;" src="@/assets/images/gov/people01_01.png"/>
            <div class="name">Mr. Bolat AKCHULAKOV</div>
            <div class="country">Country: Kazakhstan</div>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="people-row mb0">
          <el-col :span="8">
            <div class="title">
              Vice-Presidents
            </div>
            <img src="@/assets/images/gov/people02.png"/>
            <div class="name">Ms. Daniela POPESCU</div>
            <div class="country">Country：Romania</div>
            <div class="info">Romania Europe and North America region</div>
          </el-col>
          <el-col :span="8">
            <div class="title">

            </div>
            <img src="@/assets/images/gov/people02.png"/>
            <div class="name">Ms. Katannia PLUMMER-MITCHELL</div>
            <div class="country">Country：Jamaica</div>
            <div class="info">Latin America and the region Caribbean</div>
          </el-col>
          <el-col :span="8">
            <div class="title"></div>
            <img src="@/assets/images/gov/people02.png"/>
            <div class="name">Ms. Young Shik KIM</div>
            <div class="country">Country：Korea</div>
            <div class="info">Asia and the Pacific region</div>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="people-row none">
          <el-col :span="8">
            <div class="title"></div>
            <img src="@/assets/images/gov/people01.png"/>
            <div class="name">Mr. Ahogbédji Gabin ALLOGNON</div>
            <div class="country">Country：Benin</div>
            <div class="info">Africa region</div>
          </el-col>
          <el-col :span="8">
            <div class="title"></div>
            <img src="@/assets/images/gov/people01.png"/>
            <div class="name">Mr. Mokhtar FARHAT</div>
            <div class="country">Country：Tunisia</div>
            <div class="info">Arab Sates region</div>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="people-row">
          <el-col :span="8">
            <div class="title">Treasurer</div>
            <img src="@/assets/images/gov/people01.png"/>
            <div class="name">Mr. Dzmitry SUBTSLNY</div>
            <div class="country">Country：Belarus</div>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="people-row">
          <el-col :span="8">
            <div class="title">
              Members
            </div>
            <img src="@/assets/images/gov/people01.png"/>
            <div class="name">Mr. Ioannis MARONITIS</div>
            <div class="country">Country：Greece</div>
            <div class="info">Europe and North America region</div>
          </el-col>
          <el-col :span="8">
            <div class="title"></div>
            <img src="@/assets/images/gov/people01.png"/>
            <div class="name">Mr. Nazir SHARIFI</div>
            <div class="country">Country：Tajikistan</div>
            <div class="info"> Asia and the Pacific region</div>
          </el-col>
          <el-col :span="8">
            <div class="title"></div>
            <img src="@/assets/images/gov/people01.png"/>
            <div class="name">Mr. Augustin BOUDA</div>
            <div class="country">Country：Burkina-Faso</div>
            <div class="info">Africa region</div>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="people-row">
          <el-col :span="8">
            <div class="title long">Ex-Officio Members</div>
            <div class="sub-title">Chinese National Federation of Clubs and Associations for UNESCO
              (CNFUCA)
              Represented by:
            </div>
            <img src="@/assets/images/gov/people02.png"/>
            <div class="name">Ms. Aijun YUAN</div>
            <div class="country">Country：China</div>

          </el-col>
          <el-col :span="8">
            <div class="title"></div>
            <div class="sub-title" style="margin-bottom: 80px;">Italian Federation of UNESCO Centers and Clubs 
            (FICLU)
            Represented by:
            </div>
            <img src="@/assets/images/gov/people02.png"/>
            <div class="name">Ms. Maria Paola AZZARIO</div>
            <div class="country">Country：Italy</div>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="people-row">
          <el-col :span="8">
            <div class="sub-title">National Federation of Associations for UNESCO in Japan (NFUAJ)
              Represented by:
            </div>
            <img src="@/assets/images/gov/people01.png"/>
            <div class="name">Mr. Yuji SUZUKI</div>
            <div class="country">Country：Japan</div>
          </el-col>
          <el-col :span="8">
            <div class="sub-title">Vietnam Federation of Associations for UNESCO (VFUA)
              Represented by:
            </div>
            <div style="margin-top: 20px"></div>
            <img src="@/assets/images/gov/people01.png"/>
            <div class="name">Mr. Manh TRAN VAN</div>
            <div class="country">Country：Vietnam</div>
          </el-col>
        </el-row>

        <div class="page-title" id="bar33">Secretariat</div>
        <div class="text">
          The Secretariat is the permanent office of the World Federation under the stewardship of
          the
          Secretary-General. It is responsible for the day-to-day administration and financial
          management of the World Federation, the coordination and implementation of the activities
          organized by the World Federation, and reporting to the Executive Board.
        </div>

        <el-row :gutter="20" class="people-row">
          <el-col :span="8">
            <div class="title long">Secretary-General</div>
            <img src="@/assets/images/gov/people01.png"/>
            <div class="name">Mr. Yue DU</div>
            <div class="country">Country：China</div>
          </el-col>
        </el-row>

        <div class="page-title" id="bar44">Regional Federations</div>
        <div class="text">
          Regional Federations are created within the framework of the World Federation.
        </div>

        <!--      xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <el-row :gutter="0" class="people-row line">
          <el-col :span="24">
            <div class="title">Asian-Pacific Federation of Clubs and associations for UNESCO</div>
            <div class="row-flex">
              <img src="@/assets/images/gov/people02.png"/>
              <div class="row-info">
                <div class="info-item">
                  <div class="label">Acronym:</div>
                  <div class="value">AFUCA</div>
                </div>
                <div class="info-item">
                  <div class="label">Created in:</div>
                  <div class="value">1974</div>
                </div>
                <div class="info-item">
                  <div class="label">Website:</div>
                  <div class="value web" @click="goAboutList('http://www.afuca.org')">www.afuca.org</div>
                </div>
                <div class="info-item">
                  <div class="label">President:</div>
                  <div class="value">Ms Sunjoo LEE (Republic of Korea)</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- 2-->
        <el-row :gutter="0" class="people-row">
          <el-col :span="24">
            <div class="title">Confédération africaine des clubs UNESCO</div>
            <div class="row-flex">
              <img src="@/assets/images/gov/people01.png"/>
              <div class="row-info">
                <div class="info-item">
                  <div class="label">Acronym:</div>
                  <div class="value">CACU</div>
                </div>
                <div class="info-item">
                  <div class="label">Created in:</div>
                  <div class="value">1999</div>
                </div>
                <div class="info-item">
                  <div class="label">President:</div>
                  <div class="value">Mr. Ahogbédji Gabin ALLOGNON (Benin)</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <!--3-->
        <el-row :gutter="0" class="people-row">
          <el-col :span="24">
            <div class="title">European Federation of UNESCO Clubs and Associations</div>
            <div class="row-flex">
              <img src="@/assets/images/gov/people02.png"/>
              <div class="row-info">
                <div class="info-item">
                  <div class="label">Acronym:</div>
                  <div class="value">EFUCA</div>
                </div>
                <div class="info-item">
                  <div class="label">Created in:</div>
                  <div class="value">2001</div>
                </div>
                <div class="info-item">
                  <div class="label">Website:</div>
                  <div class="value web" @click="goAboutList('http://www.efuca.org')">www.efuca.org</div>
                </div>
                <div class="info-item">
                  <div class="label">President:</div>
                  <div class="value">Ms. Daniela POPESCU (Romania)</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <!--4-->
        <el-row :gutter="0" class="people-row">
          <el-col :span="24">
            <div class="title">Fédération arabe des clubs UNESCO</div>
            <div class="row-flex">
              <img src="@/assets/images/gov/people01.png"/>
              <div class="row-info">
                <div class="info-item">
                  <div class="label">Acronym:</div>
                  <div class="value">FEDACLU</div>
                </div>
                <div class="info-item">
                  <div class="label">Created in:</div>
                  <div class="value">2005</div>
                </div>
                <!--              <div class="info-item">-->
                <!--                <div class="label">Website: </div>-->
                <!--                <div class="value web">www.afuca.org</div>-->
                <!--              </div>-->
                <div class="info-item">
                  <div class="label">President:</div>
                  <!--                <div class="value">Ms Sunjoo LEE (Republic of Korea)</div>-->
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <!--5-->
        <el-row :gutter="0" class="people-row">
          <el-col :span="24">
            <div class="title">Federation of Latin America and the Caribbean of Associations and
              Clubs UNESCO
            </div>
            <div class="row-flex">
              <img src="@/assets/images/gov/people01.png"/>
              <div class="row-info">
                <div class="info-item">
                  <div class="label">Acronym:</div>
                  <div class="value">FLACACU</div>
                </div>
                <div class="info-item">
                  <div class="label">Created in:</div>
                  <div class="value">2009</div>
                </div>
                <!--              <div class="info-item">-->
                <!--                <div class="label">Website: </div>-->
                <!--                <div class="value web">www.afuca.org</div>-->
                <!--              </div>-->
                <div class="info-item">
                  <div class="label">President:</div>
                  <div class="value">Mr. Everton HANNAM (Jamaica)</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--  -------------------------------------------------------------------------    -->
      <!--    <div class="page-title">-->
      <!--      The session of Executive Board since the last World Congress-->
      <!--    </div>-->
      <!--    <div class="sub-view">-->
      <!--      <div class="sub-item">-->
      <!--        <div class="sub-title">-->
      <!--          The Extraordinary Session-->
      <!--          <div class="year">Aug 2019</div>-->
      <!--          <div class="country">Paris, France</div>-->
      <!--        </div>-->
      <!--        <div class="sub-doc">-->
      <!--          <div class="label">Documents：</div>-->
      <!--          <div class="doc-view">-->
      <!--            <a href="#" class="doc-item">Report_En</a>-->
      <!--            <a href="#" class="doc-item">Report_Fr</a>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!--      <div class="sub-item">-->
      <!--        <div class="sub-title">-->
      <!--          The 39th Ordinary Session-->
      <!--          <div class="year">Jun 2018</div>-->
      <!--          <div class="country">Chalkida, Greece</div>-->
      <!--        </div>-->
      <!--        <div class="sub-doc">-->
      <!--          <div class="label">Documents：</div>-->
      <!--          <div class="doc-view">-->
      <!--            <a href="#" class="doc-item">Report_En</a>-->
      <!--            <a href="#" class="doc-item">Report_Fr</a>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="sub-item">-->
      <!--        <div class="sub-title">-->
      <!--          The 38th Ordinary Session-->
      <!--          <div class="year">Jul 2017</div>-->
      <!--          <div class="country">Senda, Japan</div>-->
      <!--        </div>-->
      <!--        <div class="sub-doc">-->
      <!--          <div class="label">Documents：</div>-->
      <!--          <div class="doc-view">-->
      <!--            <a href="#" class="doc-item">Report_En</a>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="sub-item">-->
      <!--        <div class="sub-title">-->
      <!--          The Extraordinary Session-->
      <!--          <div class="year">Jun 2016</div>-->
      <!--          <div class="country">Shanghai, China</div>-->
      <!--        </div>-->
      <!--        <div class="sub-doc">-->
      <!--          <div class="label">Documents：</div>-->
      <!--          <div class="doc-view">-->
      <!--            <a href="#" class="doc-item">Report_En</a>-->
      <!--            <a href="#" class="doc-item">Report_Fr</a>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="sub-item">-->
      <!--        <div class="sub-title">-->
      <!--          The Extraordinary Session-->
      <!--          <div class="year">Oct 2015</div>-->
      <!--          <div class="country">Bucharest, Romania</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="sub-item">-->
      <!--        <div class="sub-title">-->
      <!--          The 37th Ordinary Session-->
      <!--          <div class="year">Jul 2015</div>-->
      <!--          <div class="country">Beijing, China</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--    </div>-->
    </div>
    <!-- 侧边栏 -->
    <ul class="side-bar">
      <t-anchor :affixProps="{ offsetTop:  affixTop}">
        <t-anchor-item
          v-for="item in barList"
          :href="`#${item.id}`"
          :title="item.name"
          style="white-space: nowrap"
        ></t-anchor-item>
      </t-anchor>
      <!-- <li
        v-for="item in barList"
        :key="item.name"
        :class="{ active: currentBar == item.id }"
      >
        <a href="javascript:;" @click="scrollTo(item)">{{ item.name }}</a>
      </li> -->
    </ul>
  </div>

</template>
<script>
import { nextTick } from "vue";

export default {
  name: "strategy",
  components: {},
  data() {
    return {
      affixTop: 600,
      barList: [
        { name: "World Congress ", id: "bar11", active: 1 },
        { name: "Executive Board", id: "bar22", active: 0 },
        { name: "Secretariat", id: "bar33", active: 0 },
        { name: "Regional Federations", id: "bar44", active: 0 },
      ],
    };
  },
  created() {},
  mounted() {
    // 获取每个模块的参数，因为模块在整页渲染完毕后，offsetTop和scrollHeight值已经是确立的，
    // 所以在滚动监听之前可以先获取，暂存在barList中。
    nextTick(() => {
      // console.log(document.documentElement.scrollTop);
      document.documentElement.scrollTop = 0;
    });
    setTimeout(() => {
      console.log(document.documentElement.scrollTop);
      document.documentElement.scrollTop = 0;
      this.barList.forEach((item) => {
        item.offsetTop = document.getElementById(item.id).offsetTop;
        item.scrollHeight = document.getElementById(item.id).scrollHeight;
        console.log("item.offsetTop", item.offsetTop);
        console.log("item.scrollHeight", item.scrollHeight);
      });
    }, 300);
    // 监听滚动事件
    window.addEventListener("scroll", this.onScroll);
  },
  destroy() {
    // 移除监听器
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    goAboutList(path) {
      if (path.indexOf("www") > -1) {
        window.open(path, "_blank");
      } else {
        // this.$router.push({path});
        // 打开新标签
        let routeData = this.$router.resolve({
          path: path, // path 要跳转的路由地址
          // query 要传递的参数
        });
        window.open(routeData.href, "_blank");
      }
    },
    // 滚动监听器
    onScroll() {
      this.affixTop = 150;
      // 获取浏览器窗口高度
      let clientHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      // 获取当前文档流的 scrollTop
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 屏幕垂直中线
      let screenMiddle = scrollTop + 150;
      // console.log("screenMiddle", screenMiddle);
      // console.log("screenMiddle - item.offsetTop", screenMiddle);
      this.barList.find((item) => {
        //以浏览器窗口垂直中线为准，中线在内容模块的上边界至下边界之间，导航栏都认为在该楼层
        // console.log("item.offsetTop", item.offsetTop);
        // console.log("item.scrollHeight", item.scrollHeight);
        if (
          screenMiddle - item.offsetTop >= 0 &&
          screenMiddle - item.offsetTop < item.scrollHeight &&
          this.scrollOn == true
        ) {
          // item.active = 1;
          this.currentBar = item.id;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.mobile {
  .side-bar {
    display: none !important;
  }

  .ob-page {
    width: 100% !important;

    .page-content {
      width: 100% !important;

      .list-item {
        line-height: 1.5em;
        text-align: left;
        font-size: 18px;
      }

      .people-view {
        .title {
          width: 90vw !important;
          font-size: 24px;
          line-height: 1.2em;
        }

        .el-col {
          width: 100% !important;

          .row-flex {
            flex-wrap: wrap;
            justify-content: center;
            margin-top: 30px;

            .row-info {
              width: 100%;
              margin: 0;
              margin-top: 10px;

              .info-item {
                align-items: flex-start;
                margin-top: 8px;
              }
            }
          }

          img {
            width: 50%;
          }
        }
      }
    }

    .page-content .img-view .img-text {
      position: static;
      color: #2a2a2a !important;
      padding: 0 !important;

      p {
        margin: 20px 0;
        text-align: justify;
      }
    }
  }

  #pane-Executive {
    .page-content .people-view .el-col-12 {
      margin-bottom: 20px;

      img {
        width: 100%;
      }

      .title {
        font-size: 18px !important;
        line-height: 24px !important;
        min-height: 80px !important;
      }

      .name {
        font-size: 16px !important;
        line-height: 20px !important;
        min-height: 40px !important;
      }
    }
  }
}

.ob-page {
  display: flex;
}

.side-bar {
  position: relative;
  flex: 1;
  height: 100%;
}

.page-content {
  width: fw(1260vw, pc) !important;
  display: block !important;

  .list-item {
    font-weight: bold;
    font-size: fh(24vh, pc);
    color: #333333;
    line-height: fh(29vh, pc);
    text-align: justify;
    font-style: normal;
    text-decoration-line: underline;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }

  .sub-title {
    font-weight: bold;
    font-size: fh(24vh, pc);
    color: #333333;
    line-height: fh(29vh, pc);
    margin: fh(40vh, pc) 0;
  }

  .text {
    p {
      margin-top: fh(8vh, pc);
      margin-bottom: fh(40vh, pc);
    }

    ul {
      margin: 0;
      padding-left: 2rem;

      li {
        margin-top: fh(0vh, pc);
        position: relative;
        color: #2a2a2a !important;

        &:before {
          content: "";
          position: absolute;
          width: 4px;
          height: 4px;
          top: fh(15vh, pc);
          left: fw(-15vw, pc);
          background-color: #0077d4;
          border-radius: 50%;
        }
      }
    }
  }

  .img-view {
    width: 100%;
    position: relative;

    img {
      width: 100%;
      display: block;
      //margin-top: fh(-200vh, pc);
    }

    .img-text {
      //background: linear-gradient(180deg, #015B73 0%, #015A73 80%, rgba(1, 90, 115, 0) 100%);
      width: 100%;
      position: absolute;
      padding: fh(40vh, pc) fw(40vw, pc);
      font-size: fh(18vh, pc);
      line-height: fh(28vh, pc);
      color: #fff;
      z-index: 9;
      font-weight: 300;

      p {
        margin-top: fh(40vh, pc);
      }

      ul {
        margin: 0;
        margin-top: 8px;

        li {
          position: relative;

          &:before {
            content: "";
            position: absolute;
            width: 4px;
            height: 4px;
            top: 50%;
            transform: translateY(-50%);
            left: fw(-25vw, pc);
            background-color: #fff;
            border-radius: 50%;
          }
        }
      }
    }
  }

  .people-view {
    .people-row {
      margin-bottom: fh(40vh, pc);

      .el-col-24 {
        color: #2a2a2a;

        .row-flex {
          display: flex;
          align-items: center;

          img {
            margin: 0;
            margin-left: fw(100vw, pc);
          }

          .row-info {
            margin-left: fw(120vw, pc);

            .info-item {
              display: flex;
              align-items: center;
              font-weight: bold;
              font-size: fh(20vh, pc);
              color: #2a2a2a;
              line-height: fh(30vh, pc);
              margin-top: fh(8vh, pc);

              .label {
                font-weight: bold;
              }

              .value {
                font-weight: 400;
                padding-left: 10px;

                &.web {
                  text-decoration: underline;
                  &:hover {
                    opacity: 0.8;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
      }

      .sub-title {
        text-align: center;
      }

      &.none {
        .title {
          display: none !important;
        }
      }

      &.mb0 {
        margin-bottom: 0 !important;
      }
    }

    .el-col-12 {
      margin-bottom: fh(60vh, pc);
    }

    .title {
      // font-size: fh(36vh, pc);
      font-size: fh(24vh, pc);

      font-weight: bold;
      color: #4a92ec;
      margin-bottom: fh(15vh, pc);
      min-height: fh(80vh, pc);

      &.long {
        width: 500%;
      }
    }

    img {
      width: fw(182vw, pc);
      margin: 0 auto;
      margin-top: fh(15vh, pc);
      margin-bottom: fh(20vh, pc);
      display: block;
    }

    .name {
      font-size: fh(22vh, pc);
      line-height: fh(36vh, pc);
      font-weight: bold;
      color: #333;
      margin-bottom: fh(10vh, pc);
      text-align: center;
    }

    .country,
    .info {
      font-size: fh(16vh, pc);
      line-height: fh(36vh, pc);
      color: #2a2a2a;
      text-align: center;
    }
  }

  .sub-view {
    width: 100%;

    .sub-item {
      margin-bottom: fh(20vh, pc);
      color: #333333;
      padding: fh(40vh, pc) fw(40vw, pc);
      background-color: #f7f7f7;
      border-radius: 8px;

      .sub-title {
        width: 100%;
        display: flex;
        align-items: center;
        font-size: fh(32vh, pc);
        line-height: fh(38vh, pc);
        font-weight: bold;
        margin-bottom: fh(40vh, pc);

        .year {
          margin-left: fw(60vw, pc);
          font-size: fh(24vh, pc);
          line-height: fh(30vh, pc);
          font-weight: normal;
        }

        .country {
          margin-left: fw(20vw, pc);
          font-size: fh(24vh, pc);
          line-height: fh(30vh, pc);
          font-weight: normal;
        }
      }

      .sub-doc {
        width: 100%;
        display: flex;
        font-size: fh(24vh, pc);
        line-height: fh(30vh, pc);

        .label {
          color: #999;
          margin-right: fw(20vw, pc);
        }

        .doc-view {
          .doc-item {
            display: block;
            color: #333;
            text-decoration: underline;
            margin-bottom: fh(24vh, pc);

            &:nth-last-child(1) {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }

  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
    margin-top: fh(40vh, pc);
  }

  .text {
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(28vh, pc);
    margin-bottom: fh(60vh, pc);
  }
}
</style>
